import React from 'react';
import { useTranslation } from 'react-i18next';
import VotingResult from '../../common/VotingResult';
import Card from '../../common/Card/Card';
import ChevronLink from '../../common/ChevronLink/ChevronLink';
import './VotingDataCard.css';
import IconText from '../../common/IconText/IconText';
import { getColors } from '../../../Constants';
import './VotingUnityCard.css';
import type { VotesQuery } from '../../../api';
import { useFormatters } from '../../../utils/texts';

type Props = {
    data: VotesQuery;
};

export const VotingUnityCard = ({ data }: Props) => {
    const { t, i18n } = useTranslation(['votings', 'analyses']);
    const { id_hlasovani, ano = 0, ne = 0, zdrzel_se = 0, cislo_hlasovani, predmet_hlasovani, vysledek, vote_match } = data;
    const colors = getColors();
    const currentLocale = i18n.language;
    const formatter = useFormatters(currentLocale);
    const vote_match_number = Number(vote_match);

    const renderVotingResults = (isMobile: boolean) => {
        return (
            <div className={`voting-unity-voting-results${isMobile ? ' for-mobile' : ' for-desktop'}`}>
                {ano > 0 && (
                    <IconText
                        icon='check_box'
                        text={ano?.toString()}
                        iconAndHighlightColor={colors.success}
                        highlightSubString={ano?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
                {ne > 0 && (
                    <IconText
                        icon='disabled_by_default'
                        text={ne?.toString()}
                        iconAndHighlightColor={colors.error}
                        highlightSubString={ne?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
                {zdrzel_se > 0 && (
                    <IconText
                        icon='indeterminate_check_box'
                        text={zdrzel_se?.toString()}
                        iconAndHighlightColor={colors.darkGray}
                        highlightSubString={zdrzel_se?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <Card className='voting-card voting-unity-card'>
                <div className='data-card-header'>
                    <div>
                        {/* Currently missing in the response */}
                        {/* <h6>{cislo_zasedani}</h6> */}
                        <h6>{`${t('VotingDataUnityCard.no.', { num: cislo_hlasovani })}`}</h6>
                        <VotingResult voteResult={vysledek} />
                    </div>
                    {renderVotingResults(false)}
                    <h6>{`${t('VotingDataUnityCard.agreement', { percentage: formatter.percent2From100(vote_match_number) })}`}</h6>
                </div>
                <div className='data-card-body clipped-text'>
                    <p>{predmet_hlasovani ? predmet_hlasovani : <i>*&nbsp;{t('votingWithoutDescription')}&nbsp;*</i>}</p>
                    <div className='voting-unity-voting-results-mobile-wrapper for-mobile'>
                        {renderVotingResults(true)}
                        <ChevronLink
                            chevronDirection='right'
                            text={t('VotingDataUnityCard.votingDetail')}
                            linkUrl={`${id_hlasovani}`}
                            linkDisabled
                        />
                    </div>
                    <ChevronLink
                        className='for-desktop'
                        chevronDirection='right'
                        text={t('VotingDataUnityCard.votingDetail')}
                        linkUrl={`${id_hlasovani}`}
                        linkDisabled
                    />
                </div>
            </Card>
        </>
    );
};
